import { render, staticRenderFns } from "./previewTableData.vue?vue&type=template&id=8c1d9a92&scoped=true&"
import script from "./previewTableData.vue?vue&type=script&lang=js&"
export * from "./previewTableData.vue?vue&type=script&lang=js&"
import style0 from "./previewTableData.vue?vue&type=style&index=0&id=8c1d9a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1d9a92",
  null
  
)

export default component.exports